import React from 'react';
import '../header/header.style.scss'
const Footer = () => {
    const year = new Date().getFullYear();
    return(
        <footer class="footer">
  <div class="content has-text-centered">
  <p className="copyright">
    Copyright &copy; {year} Midecodes
      <br/><span> All Rights Reserved.</span>
    </p>
  </div>
</footer>
    )
}

export default Footer;